import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';

import initializeApp, { Params } from 'Jsx/Shared/LayoutV2/initializeApp';

import App, { AppComplexProps } from './App';

import localeEs from './i18n/localeEs';
import localePt from './i18n/localePt';

import getInitialState from './getInitialState';
import { initialStatePageKey, CREHANA_LIVE_PAGE_KEY } from './constants';

const extraState = {
  // @ts-expect-error - This is a global variable that is not typed.
  liveCategories: window.__INITIAL_STATE__.categories,
};

function RoutedApp(props: AppComplexProps) {
  return (
    <Router>
      <App {...props} />
    </Router>
  );
}

const appConfig: Params = {
  App: RoutedApp,
  getInitialState,
  initialStatePageKey,
  i18nConfig: {
    pageKey: CREHANA_LIVE_PAGE_KEY,
    defaults: {
      ...localeEs,
      ...localePt,
    },
  },
  layoutProps: {
    // Handled manually
    userActivityPageView: null,
  },
  extraState,
};

if (module.hot) {
  module.hot.accept('./App.tsx', function () {
    initializeApp(appConfig);
  });
}

initializeApp(appConfig);
